import { Routes } from '@angular/router';
import { LayoutDemoComponent } from './components/layout-demo/layout-demo.component';
import { AuthGuard, LabAdminRestrictedGuard } from './core/auth';

export const routes: Routes = [
  {
    path: 'patient-smile-upload',
    loadComponent: () =>
      import('./app-modules/patient-smile-upload').then(module => module.PatientSmileUploadPageComponent),
  },
  {
    path: 'layout-demo',
    component: LayoutDemoComponent,
  },
  {
    path: 'account',
    loadChildren: () => import('./app-modules/user-account/user-account.routing').then(x => x.UserAccountRoutes),
    canActivate: [],
  },
  {
    path: 'workflow',
    loadChildren: () => import('./app-modules/workflow/workflow.routing').then(x => x.WorkflowRoutes),
    canActivate: [LabAdminRestrictedGuard],
  },
  {
    path: 'm',
    loadChildren: () => import('./layouts').then(m => m.MainRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'm',
  },
  {
    path: '**',
    redirectTo: 'm',
  },
];
